// App
import App from "./App.vue";
// libraries
import Vue from "vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueAnalytics from "vue-analytics";
import { VueMaskDirective } from "v-mask";
import VueEllipseProgress from "vue-ellipse-progress";
import Croppa from "vue-croppa";
//Interceptors
import "./services/interceptors";

import "./registerServiceWorker";
import { messaging } from "@/firebase";
import { onMessage } from "firebase/messaging";

const IS_LOCAL = process.env.VUE_APP_IS_LOCAL == "true";
const IS_STAGING = process.env.VUE_APP_IS_STAGING == "true";

// Vue Mask
Vue.config.productionTip = false;
Vue.directive("mask", VueMaskDirective);

// Analytics
Vue.use(VueAnalytics, {
   id: process.env.VUE_APP_ANALYTICS_KEY,
   router
});

// Vue Ellipse Progress
Vue.use(VueEllipseProgress);

//Vue Croppa
Vue.use(Croppa);

// DevTools Config
if (IS_LOCAL || IS_STAGING) {
   Vue.config.devtools = true;
   Vue.config.performance = true;
}

new Vue({
   router,
   store,
   vuetify,
   render: h => h(App),
   mounted() {
      if (messaging) {
         onMessage(messaging, payload => {
            // eslint-disable-next-line no-console
            console.log("Message received. ", payload);
            // ...
            const notificationTitle = payload.notification.title;
            const notificationOptions = {
               body: payload.notification.body,
               icon: "/img/icons/android-chrome-192x192.png"
            };

            if (!("Notification" in window)) {
               // eslint-disable-next-line no-console
               console.log("This browser does not support system notifications");
            } else if (Notification.permission === "granted") {
               // eslint-disable-next-line no-unused-vars
               var notification = new Notification(notificationTitle, notificationOptions);
            }
         });
      }
   }
}).$mount("#app");
